
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/x/react-tree-view/quickstart",
      function () {
        return require("private-next-pages/x/react-tree-view/quickstart.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/x/react-tree-view/quickstart"])
      });
    }
  